"use strict";

exports.__esModule = true;
exports.EditableDeviceGridElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _getNonWidgetProps = require("../../ConfigurableLayout/common/getNonWidgetProps");
var _FlexPassthrough = require("../../Core/FlexGrid/FlexPassthrough");
var _StaticFlexGrid = require("../../Core/FlexGrid/StaticFlexGrid");
var _DeviceContext = require("../../Device/DeviceContext");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _MetricValueBatchProvider = require("../MetricValue/MetricValueBatchProvider");
var _excluded = ["device", "x", "y", "width", "height"],
  _excluded2 = ["width", "height", "itemWidth", "itemHeight", "itemBackgroundColor", "itemBorderColor", "x", "y", "columnGutter", "rowGutter"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var EditableDeviceGridElementContainer = _styledComponents["default"].div.withConfig({
  displayName: "EditableDeviceGridElement__EditableDeviceGridElementContainer",
  componentId: "sc-gdgq4n-0"
})(["background-color:transparent;"]);
var EditableDeviceGridElementDeviceContainer = _styledComponents["default"].article.withConfig({
  displayName: "EditableDeviceGridElement__EditableDeviceGridElementDeviceContainer",
  componentId: "sc-gdgq4n-1"
})(["position:absolute;border:solid 1px rgba(0,0,0,0.2);overflow:hidden;"]);

/**
 * Displays a virtualized grid of devices, repeating the supplied
 * element children for each device.
 */
var EditableDeviceGridElement = exports.EditableDeviceGridElement = /*#__PURE__*/function (_Component) {
  function EditableDeviceGridElement() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.renderDevice = function (_ref) {
      var device = _ref.device,
        x = _ref.x,
        y = _ref.y,
        width = _ref.width,
        height = _ref.height,
        extra = _objectWithoutPropertiesLoose(_ref, _excluded);
      var _this$props = _this.props,
        children = _this$props.children,
        render = _this$props.render,
        itemBorderColor = _this$props.itemBorderColor;
      var transform = "translate3d(" + x + "px, " + y + "px, 0)";
      var style = {
        transform: transform,
        width: Math.floor(width),
        height: Math.floor(height),
        borderColor: itemBorderColor
      };
      return /*#__PURE__*/_react["default"].createElement(EditableDeviceGridElementDeviceContainer, {
        style: style
      }, /*#__PURE__*/_react["default"].createElement(_DeviceContext.DeviceContext.Provider, {
        value: device
      }, _react["default"].Children.map(render(children), function (child) {
        return /*#__PURE__*/_react["default"].cloneElement(child, Object.assign({
          width: width,
          height: height
        }, extra));
      })));
    };
    return _this;
  }
  _inheritsLoose(EditableDeviceGridElement, _Component);
  var _proto = EditableDeviceGridElement.prototype;
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var props = this.props;
    return props.width !== nextProps.width || props.height !== nextProps.height || props.itemWidth !== nextProps.itemWidth || props.itemHeight !== nextProps.itemHeight || props.columnGutter !== nextProps.columnGutter || props.rowGutter !== nextProps.rowGutter || !(0, _reactFastCompare["default"])(props.children, nextProps.children);
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      width = _this$props2.width,
      height = _this$props2.height,
      itemWidth = _this$props2.itemWidth,
      itemHeight = _this$props2.itemHeight,
      itemBackgroundColor = _this$props2.itemBackgroundColor,
      itemBorderColor = _this$props2.itemBorderColor,
      x = _this$props2.x,
      y = _this$props2.y,
      columnGutter = _this$props2.columnGutter,
      rowGutter = _this$props2.rowGutter,
      extra = _objectWithoutPropertiesLoose(_this$props2, _excluded2);
    return /*#__PURE__*/_react["default"].createElement(_DeviceListContext.DeviceListContext.Consumer, null, function (devices) {
      var column = columnGutter == null ? 16 : columnGutter;
      var row = rowGutter == null ? 16 : rowGutter;
      var perRow = Math.floor(width / (itemWidth + column)) || 1;
      var rows = Math.ceil(height / (itemHeight + row)) || 1;
      var visibleCount = Math.min((devices == null ? void 0 : devices.length) || 0, perRow * rows);
      return /*#__PURE__*/_react["default"].createElement(_MetricValueBatchProvider.MetricValueBatchProvider, {
        devices: devices,
        visibleDevices: (devices || []).slice(0, visibleCount),
        elements: _this2.props.children,
        backgroundColorSource: _this2.props.backgroundColorSource
      }, /*#__PURE__*/_react["default"].createElement(EditableDeviceGridElementContainer, null, /*#__PURE__*/_react["default"].createElement(_StaticFlexGrid.StaticFlexGrid, _extends({
        width: width,
        height: height,
        itemWidth: itemWidth,
        itemHeight: itemHeight,
        columnGutter: columnGutter,
        rowGutter: rowGutter,
        itemCount: devices == null ? void 0 : devices.length
      }, (0, _getNonWidgetProps.getNonWidgetProps)(extra), {
        renderItem: function renderItem(_ref2) {
          var index = _ref2.index;
          return (devices == null ? void 0 : devices.length) > 0 ? /*#__PURE__*/_react["default"].createElement(_FlexPassthrough.FlexPassthrough, {
            key: index,
            device: devices[index]
          }, _this2.renderDevice) : null;
        }
      }))));
    });
  };
  return EditableDeviceGridElement;
}(_react.Component);
EditableDeviceGridElement.defaultProps = {
  width: 1024,
  height: 768,
  itemBackgroundColor: "#fff",
  itemBorderColor: "rgba(0, 0, 0, 0.2)"
};